import { SectionHeading } from "@/components/ui-ext/SectionHeading";
import { Picture } from "@/components/media/Picture";
import { siteConfig } from "@/config/site";

const PHASES = [
  {
    w: "Week 0",
    t: "Discovery & baseline",
    d: "Business goals, unit economics, buyer journey, current stack. We benchmark you against three competitors on Semrush and GSC before we write a single deliverable.",
  },
  {
    w: "Weeks 1–3",
    t: "Full technical + content audit",
    d: "Crawl, indexation, CWV, schema, canonicals, IA, topical coverage, backlink profile, GBP, AI-visibility scoring. Every finding logged with owner and priority.",
  },
  {
    w: "Week 4",
    t: "Roadmap review & kickoff",
    d: "Prioritised, dated roadmap presented to your leadership team. Alignment on scope, owners, and the KPI dashboard we'll run the programme against.",
  },
  {
    w: "Months 2–3",
    t: "Foundation phase",
    d: "Technical fixes ship. Schema deploys. IA rebuilds land. Priority commercial pages get rewritten. GBP overhaul. First content sprints publish.",
  },
  {
    w: "Months 4–6",
    t: "Compounding phase",
    d: "Digital PR programme launches. Topical clusters expand. AEO/GEO optimisation on every priority page. Weekly stand-ups and monthly executive reviews.",
  },
  {
    w: "Month 6+",
    t: "Growth engine mode",
    d: "The programme becomes a system: content decay monitoring, refresh cycles, authority campaigns, quarterly strategic reviews. Predictable compounding organic revenue.",
  },
];

export function HomeProcess() {
  return (
    <section className="container-page py-16 md:py-24">
      <SectionHeading
        eyebrow="How we work"
        title={<>Six phases. Zero <span className="text-gradient">vendor black-box</span>.</>}
        intro={`Every phase has a defined output, an owner, and a review gate. You always know what's shipping this week and why at ${siteConfig.name}.`}
      />
      <div className="mt-12 rounded-2xl overflow-hidden border border-border">
        <Picture
          variantKey="process"
          alt={`${siteConfig.name} SEO engagement process`}
          width={1600}
          height={900}
          sizes="(min-width: 1024px) 1100px, 100vw"
        />
      </div>
      <div className="mt-16 relative">
        <div
          aria-hidden
          className="hidden md:block absolute left-[7rem] top-2 bottom-2 w-px"
          style={{ background: "linear-gradient(180deg, transparent, var(--border-strong) 10%, var(--border-strong) 90%, transparent)" }}
        />
        <ol className="space-y-6">
          {PHASES.map((p, i) => (
            <Reveal
              key={p.w}
              as="li"
              delay={(i % 4) as 0 | 1 | 2 | 3}
              className="grid md:grid-cols-[7rem_1fr] gap-5 md:gap-10 items-start"
            >
                <div className="flex md:justify-end">
                  <div className="inline-flex items-center gap-2">
                    <div className="hidden md:flex h-3 w-3 rounded-full bg-primary shadow-[var(--shadow-glow)]" />
                    <div className="text-[0.7rem] uppercase tracking-[0.18em] text-primary whitespace-nowrap">
                      {p.w}
                    </div>
                  </div>
                </div>
                <article className="surface-card p-6 hover-lift">
                  <h3 className="font-display text-xl">{p.t}</h3>
                  <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
                    {p.d}
                  </p>
                </article>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}

import { Reveal } from "@/components/ui-ext/Reveal";
